import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { Card, CardBody } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts";
import ItemService from "./Item.service";
import AuthService from "../Authentication/auth.service";
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createGlobalStyle } from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import { getFileUrl, uploadFile } from "../../utils/fileUtils";


const imageStyle = {
  width: 'auto',
  height: '200px',
  objectFit: 'cover',
  margin: '0px auto',
};

const slideStyle = {};

const customSliderStyles = `
  .slick-prev,
  .slick-next {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    z-index: 1;
  }

  .slick-prev:hover,
  .slick-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${customSliderStyles}
`;

const DriverUpdationForm = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const [pre_params, setpre_params] = useState('');
  const [collectionlist, setcollectionlist] = useState([]);
  const [fieldlist, setfieldlist] = useState([]);
  const [fieldlist_validate, setfieldlist_validate] = useState([]);
  const [fieldvalues, setfieldvalues] = useState({});
  const [item_name, setItem_name] = useState(state?.item_name);
  const [itemType, setItemType] = useState(state?.item_type);
  // const [amount, setamount] = useState(state?.amount);
  const [description, setDescription] = useState(state?.description);
  const [selectedImages, setSelectedImages] = useState(state?.Images || []);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [errors, setErrors] = useState({});
  const [categoryError, setCategoryError] = useState('');
  const [statusError, setStatusError] = useState('');
  const [skuError, setSkuError] = useState('');
  const [businessError, setBusinessError] = useState('');
  const [imageError, setImageError] = useState('');
  const stored_user = authData.userData;
  let business = []
  if (stored_user.businesses) {
    business = stored_user.businesses
  }
  console.log("business:", business);

  useEffect(() => {

    i18n.changeLanguage(localStorage.getItem('language'));
    fetchDynamicData();
    console.log(state)
  }, []);

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) {
      return;
    }

    setLoading(true);
    try {
      const paths = await Promise.all(files.map((file) => uploadFile(file)));
      setSelectedImages((prevImages) => [...prevImages, ...paths]);
    } catch (error) {
      Alerts.swalErrorAlert(error.message || t("Image upload failed."));
    } finally {
      setLoading(false);
    }
  };


  const sliderStyle = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
  }
  const ImageSlideshow = ({ images, onRemove }) => {
    if (images.length === 0) return null;

    const removeButtonStyle = {
      position: 'absolute',
      top: '10px',
      right: '10px',
      background: 'rgba(255, 0, 0, 0.7)',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      cursor: 'pointer',
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: 'bold',
    };

    if (images.length === 1) {
      return (
        <div style={{ ...sliderStyle, textAlign: 'center', position: 'relative' }}>
          <img src={getFileUrl(images[0])} alt="Single Image" style={imageStyle} />
          <button
            onClick={() => onRemove(0)}
            style={removeButtonStyle}
          >
            X
          </button>
        </div>
      );
    }

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
    };

    return (
      <div style={{ ...sliderStyle, position: 'relative' }}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} style={{ position: 'relative' }}>
              <img src={getFileUrl(image)} alt={`Slide ${index + 1}`} style={imageStyle} />
            </div>
          ))}
        </Slider>
        {images.map((_, index) => (
          <button
            key={`remove-${index}`}
            onClick={() => onRemove(index)}
            style={removeButtonStyle}
            className="remove-button"
          >
            X
          </button>
        ))}
      </div>
    );
  };


  const removeImage = (index) => {
    setSelectedImages(prevImages => prevImages.filter((_, i) => i !== index));
  };
  const fetchDynamicData = async () => {
    try {
      const response = await ItemService.get_cruds_dynamic_data(authData.sessionID);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        const data = await response.data;

        var custom_fields = data;
        for (var i = 0; i < custom_fields.length; i++) {
          if (custom_fields[i].options_collection !== '') {
            const _id = authData.userData._id
            const optresponse = await ItemService.getoptions(custom_fields[i].options_collection, "", {}, 5000, authData.sessionID, _id);
            const optdata = await optresponse.data.data;
            var options = [];

            for (var j = 0; j < optdata.length; j++) {
              options.push({ label: optdata[j][custom_fields[i].Options_Field_Name], value: optdata[j]._id, business_id: optdata[j]?.business_id ? optdata[j]?.business_id : null, status: optdata[j]?.Status ? optdata[j]?.Status : null })
            }
            custom_fields[i].options = options;
          }
          if (custom_fields[i].parent_col === pre_params.Parent_referal_name) {
            custom_fields[i].default_value = pre_params.Parentid
          } else {
            custom_fields[i].default_value = ""
          }
        }

        data[0].custom_fields = custom_fields;

        setcollectionlist(data[0]);
        setfieldlist(data[0].custom_fields);
        var cust = data[0].custom_fields;
        var validations = {};
        for (var i = 0; i < cust.length; i++) {
          validations[cust[i].referal_name] = cust[i].is_required;
        }
        setfieldlist_validate(validations);
      }
    } catch (error) {
      console.log("error", error);
    }
  };


  
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!item_name.trim()) {
      formErrors.item_name = "Item Name is required";
      isValid = false;
    }
    if (!description.trim()) {
      formErrors.description = "Description is required";
      isValid = false;
    }
    // if (!amount) {
    //   formErrors.amount = "Price is required";
    //   isValid = false;
    // }
    if (!itemType) {
      formErrors.item_type = "Item Type is required";
      isValid = false;
    }

    // Category validation
    const categoryField = fieldlist.find(field => field.referal_name === 'category');
    if (categoryField) {
      const categoryValue = document.getElementById(categoryField.referal_name)?.value;
      if (!categoryValue) {
        formErrors[categoryField.referal_name] = "Category is required";
        setCategoryError("Category is required");
        isValid = false;
      } else {
        setCategoryError("");
      }
    }

    // Status validation
    const statusField = fieldlist.find(field => field.referal_name === 'status');
    if (statusField) {
      const statusValue = document.getElementById(statusField.referal_name)?.value;
      if (!statusValue) {
        formErrors[statusField.referal_name] = "Status is required";
        setStatusError("Status is required");
        isValid = false;
      } else {
        setStatusError("");
      }
    }

    

    // Business validation
    const businessField = fieldlist.find(field => field.referal_name === 'business_id');
    if (businessField) {
      const businessValue = document.getElementById(businessField.referal_name)?.value;
      if (!businessValue) {
        formErrors[businessField.referal_name] = "Business is required";
        setBusinessError("Business is required");
        isValid = false;
      } else {
        setBusinessError("");
      }
    }


    // Business validation
    const skuField = fieldlist.find(field => field.referal_name === 'business_id');
    if (skuField) {
      const skuValue = document.getElementById(skuField.referal_name)?.value;
      if (!skuValue) {
        formErrors[skuField.referal_name] = "Business is required";
        setBusinessError("Business is required");
        isValid = false;
      } else {
        setBusinessError("");
      }
    }


  

    // Image validation
    const imageField = fieldlist.find(field => field.referal_name === 'images');
    if (imageField && selectedImages.length === 0) {
      formErrors[imageField.referal_name] = "At least one image is required";
      isValid = false;
    }

    // Other field validations
    fieldlist.forEach(field => {
      if (field.show_in === 'Items List' && field.status === 'Active' &&
        (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items')) {
        const value = document.getElementById(field.referal_name)?.value;
        if (field.is_required && !value) {
          formErrors[field.referal_name] = `${field.field_lable} is required`;
          isValid = false;
        }
      }
    });

    setErrors(formErrors);
    return isValid;
  };

  

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    var requestData = {};

    for (var i in fieldlist) {
      var field = fieldlist[i];
      if (field.show_in === 'Items List' && field.status === 'Active') {
        if (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items') {
          if (field.field_type === 'radio') {
            const elements1 = document.querySelectorAll('.prop' + field.referal_name + ':checked');
            var elementvalue = elements1.length > 0 ? elements1[0].value : null;
            requestData[field.referal_name] = elementvalue;
          } else if (field.field_type === 'checkbox') {
            const elements1 = document.querySelectorAll('.prop' + field.referal_name + ':checked');
            var elementvalue = Array.from(elements1).map(el => el.value);
            requestData[field.referal_name] = elementvalue.length > 0 ? elementvalue : 0;
          } else {
            var fieldvalue = document.getElementById(field.referal_name)?.value;
            requestData[field.referal_name] = fieldvalue;
          }
        }
      }
    }

    requestData._id = state._id;
    requestData.functionName = "UpdateItems";
    requestData.formId = collectionlist._id;
    requestData.user_type_id = collectionlist._id;
    requestData.user_type = collectionlist.name;
    requestData.collection_name = collectionlist.collection_name;
    requestData.Images = selectedImages;
    requestData.item_name = item_name;
    requestData.description = description;
    // requestData.amount = amount;
    requestData.item_type = itemType;

    setLoading(true);

    ItemService.save_item(requestData, authData.sessionID)
      .then((response) => {
        setLoading(false);
        if (response.data.status) {
          navigate("/items-list");
          if (response.data.message) {
            Alerts.swalSuccessAlert(response.data.message);
          } else {
            Alerts.swalSuccessAlert(t("Data Updated successfully."));
          }
        } else {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            Alerts.swalErrorAlert(response.data.message || t("Error: Can't update data at the moment. Please try again later."));
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Network Operation failed."));
      });
  }

  const handle_change = (e) => {
    var value = e.target.value;
    var referal_name = e.target.id;

    var custom_fields = fieldlist;
    var datafield_values = {};
    for (var i = 0; i < custom_fields.length; i++) {

      if (custom_fields[i].referal_name === referal_name) {
        custom_fields[i].fieldvalue = value
        datafield_values[custom_fields[i].referal_name] = value
      } else {
        datafield_values[custom_fields[i].referal_name] = custom_fields[i].fieldvalue;
      }

    }
    setfieldvalues(datafield_values);
  }

  const handle_optionchange = (e) => {

    var element = e.target
    var value = element.value;
    var referal_name = element.name;
    var type = element.type;
    var custom_fields = fieldlist;
    var datafield_values = {};
    for (var i = 0; i < custom_fields.length; i++) {

      if (custom_fields[i].referal_name === referal_name) {

        if (type === "radio") {
          custom_fields[i].fieldvalue = value
          datafield_values[custom_fields[i].referal_name] = value
        }

        if (type === "checkbox") {
          var fieldvals = custom_fields[i].fieldvalue;
          if (typeof fieldvals === "string") {
            var cval = fieldvals;
            fieldvals = [];
            fieldvals = cval.split(",");
          }


          if (typeof fieldvals === "object") {

            if (!element.checked) {
              var index = fieldvals.indexOf(value);
              if (index !== -1) {

                fieldvals.splice(index, 1);
              }
            } else {

              fieldvals.push(value);


            }
          }
          custom_fields[i].fieldvalue = fieldvals
          datafield_values[custom_fields[i].referal_name] = fieldvals
        }



      } else {
        datafield_values[custom_fields[i].referal_name] = custom_fields[i].fieldvalue;
      }

    }
    setfieldvalues(datafield_values);
  }
  const [selectedBusiness, setSelectedBusiness] = useState(state.business_id || '');
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(state.category || '');

  useEffect(() => {
    // Filter categories based on the pre-selected business
    if (selectedBusiness) {
      const categoryField = fieldlist?.find(field => field.referal_name === 'category');
      const categories = categoryField?.options?.filter(option => option.business_id.toString() === selectedBusiness) || [];
      setFilteredCategories(categories);
    }
  }, [selectedBusiness, fieldlist]);

  const handleBusinessChange = (event) => {
    const businessId = event.target.value;
    setSelectedBusiness(businessId);
    setSelectedCategory(''); // Reset category when business changes
    // Filter categories based on the selected business
    const categoryField = fieldlist?.find(field => field.referal_name === 'category');
    const categories = categoryField?.options?.filter(option => option.business_id.toString() === businessId) || [];
    setFilteredCategories(categories);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };



  // const handleBusinessChange = (event) => {
  //   const businessId = event.target.value;
  //   setSelectedBusiness(businessId);
  //   // Filter categories based on the selected business
  //   const categories = fieldlist.find(field => field.referal_name === 'category').options.filter(option => option.business_id.toString() === businessId);
  //   setFilteredCategories(categories);
  // };




  return (
    <>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-plus icon-gradient bg-happy-green" />
                </div>

                <div>{t("Update Item")}
                  <div className="page-title-subheading">
                    {t('Fill the form below to update Items')}
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-6">
              <Card className="main-card mb-3">
                <CardBody>
                  <LoadingOverlay tag="div" active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}>
                    <Form onSubmit={handleSubmit} initial={state} ref={form}>
                      <div className="row" key={'name'}>
                        <div className="col-md-12 col-xl-12" >
                          <div className="form-group" >
                            <label htmlFor="name">{t("Item Name")} <span id={"name error-box"} style={{ color: "red" }}></span></label>
                            <Input type='text'
                              value={item_name}
                              onChange={(e) => { setItem_name(e.target.value) }}
                              className="form-control" placeholder={t("Item Name")} name="item_name" id="item_name" />

                                {errors.item_name && <div style={{color:'red'}}>{errors.item_name}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row" key={'description'}>
                        <div className="col-md-12 col-xl-12" >
                          <div className="form-group" >
                            <label htmlFor="description">{t("Description")} <span id={"description error-box"} style={{ color: "red" }}></span></label>
                            <Input
                              value={description}
                              onChange={(e) => { setDescription(e.target.value) }}
                              type='text' className="form-control" placeholder={t("Description")} name="description" id="description" />
                              {errors.description && <div style={{color:'red'}}>{errors.description}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      {/* <div className="row" key={'amount'}>
                        <div className="col-md-12 col-xl-12" >
                          <div className="form-group" >
                            <label htmlFor="amount">{t("amount")} <span id={"description error-box"} style={{ color: "red" }}></span></label>
                            <Input value={amount}
                              onChange={(e) => { setamount(e.target.value) }}
                              type='number' className="form-control" placeholder={t("amount")} name="amount" id="amount" />
                              {errors.amount && <div style={{color:'red'}}>{errors.amount}</div>}
                          </div>
                        </div>
                      </div> */}
                      <br />
                      <div className="row" key={'item_type'}>
                        <div className="col-md-12 col-xl-12" >
                          <div className="form-group" >
                            <label htmlFor="name">Item Type <span id={"item_type error-box"} style={{ color: "red" }}></span></label>
                            <select
                              value={itemType}
                              onChange={(e) => { setItemType(e.target.value) }}
                              className="form-select" name='item_type' id='item_type'    >
                              <option disabled={false} value="">{t('--Choose an option--')}</option>
                              <option key='Medicines' value='Medicines'>{t("Medicines")}</option>
                              <option key='IOT Devices' value='IOT Devices'>{t("IOT Devices")}</option>
                            </select>
                            {errors.item_type && <div style={{color:'red'}}>{errors.item_type}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      {fieldlist && fieldlist.map((field, index) => {
                        if (field.is_editable && field.status === 'Active' && field.show_in === 'Items List') {
                          if (field.item_in_invoice === 'Both' || field.item_in_invoice === 'Items') {

                            if (field.field_type === 'text' || field.field_type === 'email' || field.field_type === 'number' || field.field_type === 'password' || field.field_type === 'file') {
                              if (field.referal_name === 'images') {
                                return (
                                  <>
                                    <div className="row" key={index}>
                                      <div className="col-md-12 col-xl-12">
                                        <div className="form-group">
                                          <label htmlFor="images">Images</label>
                                          <Input
                                            type='file'
                                            accept="image/*"
                                            multiple
                                            className="form-control"
                                            name="images"
                                            id="images"
                                            onChange={handleFileChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <br />
                                    {selectedImages.length > 0 && (
                                      <div className="row">
                                        <div className="col-md-12 col-xl-12">
                                          <ImageSlideshow images={selectedImages} onRemove={removeImage} />
                                        </div>
                                      </div>
                                    )}
                                    {errors[field.referal_name] && <div className="invalid-feedback">{errors[field.referal_name]}</div>}
                                  </>
                                )
                              } else {
                                return (
                                  <>
                                    <div className="row" key={index}>
                                      <div className="col-md-12 col-xl-12" >
                                        <div className="form-group " >
                                          <label htmlFor="name">{field.field_lable} <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span></label>
                                          <Input type={field.field_type} className="form-control"
                                            placeholder={field.field_lable}
                                            name={field.referal_name} id={field.referal_name}
                                            value={field.field_type !== 'file' ? state[field.referal_name] : ''} />
                                        </div>
                                      </div>
                                    </div>
                                    <br />
                                  </>
                                )
                              }
                            }
                            if (field.field_type === 'dropdown') {
                              if (field.referal_name === 'business_id') {
                                return (
                                  <div className="row" key={index} style={{ display:  'none' }}>
                                    <div className="col-md-12 col-xl-12">
                                      <div className="form-group">
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          defaultValue={state[field.referal_name]}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                          onChange={handleBusinessChange}
                                        >
                                          <option disabled={false} value="">{t('--Choose an option--')}</option>
                                          {field.options?.map((option, optionsindex) => {
                                            if (super_admin) {
                                              return (
                                                <option key={field.referal_name + optionsindex} value={option.value}>
                                                  {option.label}
                                                </option>
                                              );
                                            } else if (business.length === 1) {
                                              if (business.some(b => b.toString() === option.value.toString())) {
                                                return (
                                                  <option key={field.referal_name + optionsindex} value={option.value}>
                                                    {option.label}
                                                  </option>
                                                );
                                              }
                                            } else if (business.some(b => b.toString() === option.value.toString())) {
                                              return (
                                                <option key={field.referal_name + optionsindex} value={option.value}>
                                                  {option.label}
                                                </option>
                                              );
                                            }
                                            return null;
                                          })}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                      <br />
                                    </div>
                                  </div>
                                );
                              } else if (field.referal_name === 'category') {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12">
                                      <div className="form-group">
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          value={selectedCategory}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                          onChange={handleCategoryChange}
                                        >
                                          <option disabled={false} value="">{t('--Choose an option--')}</option>
                                          {filteredCategories
                                            .filter(option => option.status === 'Active')
                                            .map((option, optionsindex) => (
                                              <option key={field.referal_name + optionsindex} value={option.value}>
                                                {option.label}
                                              </option>
                                            ))}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                      <br />
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12">
                                      <div className="form-group">
                                        <label htmlFor={field.referal_name}>{field.field_lable}
                                          <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <select
                                          name={field.referal_name}
                                          id={field.referal_name}
                                          defaultValue={state[field.referal_name]}
                                          className={`form-select form-control ${errors[field.referal_name] ? 'is-invalid' : ''}`}
                                        >
                                          <option disabled={false} value="">{t('--Choose an option--')}</option>
                                          {field.options?.map((option, optionsindex) => (
                                            <option key={field.referal_name + optionsindex} value={option.value}>{option.label}</option>
                                          ))}
                                        </select>
                                        {errors[field.referal_name] && (
                                          <div className="invalid-feedback">{errors[field.referal_name]}</div>
                                        )}
                                      </div>
                                    </div>
                                    <br />
                                  </div>
                                );
                              }
                            }
                            else if (field.field_type === 'radio' || field.field_type === 'checkbox') {
                              return (
                                <>
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12" ><label htmlFor="name">{field.field_lable} <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span></label></div>
                                    <br />
                                    <div className="col-md-12 col-xl-12" >
                                      <ul className="child mb-0 p-0">
                                        {field.options.map((option, optionsindex) => {
                                          var checked = "";
                                          var btnvalue = fieldvalues[field.referal_name];

                                          if (typeof btnvalue === "string") {
                                            if (option.value === btnvalue) {
                                              checked = "true"
                                            } else if (btnvalue.indexOf(option.value) > -1) {
                                              checked = "true"
                                            }
                                          }

                                          if (typeof btnvalue === "object") {
                                            if (btnvalue.indexOf(option.value) > -1) {
                                              checked = "true"
                                            }
                                          }
                                          return (
                                            <li className="form-check form-check-inline">
                                              <input className={"form-check-input prop" + field.referal_name}
                                                type={field.field_type}
                                                value={option.value} checked={checked} onClick={handle_optionchange} name={field.referal_name} id={field.referal_name + optionsindex}
                                              />
                                              <label className="form-check-label" htmlFor="users">
                                                {option.label}
                                              </label>
                                            </li>
                                          )
                                        })}
                                      </ul>
                                    </div>
                                  </div>
                                  <br />
                                </>
                              )
                            }
                            else {
                              return (
                                <>
                                  <div className="row" key={index}>
                                    <div className="col-md-12 col-xl-12" >
                                      <div className="form-group" >
                                        <label htmlFor="name">{field.field_lable} <span id={field.referal_name + "error-box"} style={{ color: "red" }}></span></label>
                                        <Input type="text" className="form-control" placeholder={field.field_lable} name={field.referal_name} id={field.referal_name} />
                                      </div>
                                    </div>
                                  </div>
                                  <br />
                                </>
                              )
                            }
                          }
                        }
                      })}
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12" >
                          <center>
                            <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                            <button className="btn btn-custom-color btn-hover-shine me-3 mt-3" >{t('Update data')}</button>
                          </center>
                        </div>
                      </div>
                    </Form>
                  </LoadingOverlay>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}

export default DriverUpdationForm;